<template>
  <el-container>
    <course-list :course-type="courseType" :name="courseName"></course-list>
    <recommend-course  course-type="C" style="margin-top: 80px"></recommend-course>
  </el-container>
</template>

<script>
  const CourseList = () => import('@/components/course/CourseList');
  const RecommendCourse = () => import('@/components/course/RecommendCourse')
  export default {
    name: "List",
    components: {
      CourseList,
      RecommendCourse
    },
    data() {
      return {
        courseType: 'C',
        courseName: ''
      }
    },
    created() {
      if (this.$route.query.title){
        this.courseName = this.$route.query.title;
      }
    },
    beforeRouteUpdate(to,from,next){
      this.courseName = to.query.title;
      next();
    }
  }
</script>

<style scoped>
  .el-container {
    width: 1200px;
    min-width: 1200px;
    margin: 35px auto 50px auto;
  }
</style>
